import { createSlice } from "@reduxjs/toolkit";
import { PayslipProps } from "../../types";

const initialState: PayslipProps = {
  result: null,
};

const payslipReducer = createSlice({
  name: "payslip",
  initialState: initialState,
  reducers: {
    fetchPayslipSuccess(state, action) {
      return {
        ...state,
        result: action.payload,
      };
    },
  },
});

export default payslipReducer.reducer;

export const { fetchPayslipSuccess } = payslipReducer.actions;
